<template>
  <div>
    <div class="page-content">
      <div class="wrapper">

        <div class="sideBar divide-y-2 -mt-4">

          <!--
          <div class="py-4">
            <b>Community Validation</b><br>
            <div class="mt-1">
              <router-link to="learn">Learn More</router-link>
            </div>
          </div>
          -->

        </div>

        <router-view/>

      </div>
    </div>
  </div>
</template>

<!--  eslint-disable prefer-object-spread -->
<script type="text/javascript">

export default {
  name: 'channelPage',
  data() {
    return {
    };
  },
  methods: {
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.assistMsg {
  @apply p-1 -m-1 mt-0;
  background-color: #fff2dc; /* between bg-orange-100 and bg-orange-200 */
}
  /* .sideBar .navItem { */
    /* margin-top: 5px; */
  /* } */
  /* .sideBarInfo { */
    /* margin-top: 10px; */
    /* margin-bottom: 30px; */
  /* } */
@screen md {
  .sideBar {
    @apply w-48 pr-5 mt-1; /* max-w-xs */
      /* // margin-left: 20px; */
      /* // height: 200px; */
      /* https://stackoverflow.com/questions/2997767/how-do-i-keep-two-divs-that-are-side-by-side-the-same-height */
      /* // padding-bottom: 100%; */
      /* // margin-bottom: -100%; */
  }
  .wrapper >>> > * { /* all children of wrapper (ref: deep selector) */
    @apply float-left max-w-2xl;
  }
}
.sideBar {
  /* background-color: #eee; */
  /* max-width: calc(#{$on-palm}*1/3 - (#{$spacing-unit} * 2)); */
  /* margin-right: auto; */
  /* margin-left: auto; */
  /* @extend %clearfix; */
}
</style>
